import { useQuery } from '@tanstack/react-query';
import { invoiceService } from '@/services';
import { EarlyPayChart } from '@/components/earlypay/EarlyPayChart';
import { Skeleton } from '@/components/ui/skeleton';

interface DashboardEarlyPayCardProps {
  companyId: string;
}

export function DashboardEarlyPayCard({ companyId }: DashboardEarlyPayCardProps) {
  const { data: invoices, isLoading } = useQuery({
    queryKey: ['dashboard-early-pay', companyId],
    queryFn: async () => {
      const result = await invoiceService.listForEarlyPay(companyId);
      return result.data || [];
    },
    staleTime: 5 * 60 * 1000,
    enabled: !!companyId,
  });

  if (isLoading) {
    return (
      <div className="p-6 space-y-4">
        <Skeleton className="h-6 w-48" />
        <Skeleton className="h-[300px] w-full" />
      </div>
    );
  }

  if (!invoices || invoices.length === 0) {
    return (
      <div className="p-6 h-full flex items-center justify-center text-muted-foreground">
        No early pay discount data available
      </div>
    );
  }

  return (
    <div className="h-full [&_.rounded-lg]:border-0 [&_.rounded-lg]:shadow-none">
      <EarlyPayChart invoices={invoices} />
    </div>
  );
}
